import { render, staticRenderFns } from "./TermsEdit.vue?vue&type=template&id=4070f0b3&scoped=true&"
import script from "./TermsEdit.vue?vue&type=script&lang=js&"
export * from "./TermsEdit.vue?vue&type=script&lang=js&"
import style0 from "./TermsEdit.vue?vue&type=style&index=0&id=4070f0b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070f0b3",
  null
  
)

export default component.exports